import React from 'react'
import PropTypes from 'prop-types'

import ColorItem from './ColorItem'

import './styles.scss'

const baseClass = 'user-board-main-color-panel'

const ActivityColorPanel = ({ actionsColorsInfo, showStats }) => {
  const colors = (
    <div className={baseClass}>
      {actionsColorsInfo.map((status, index) => (
        <ColorItem key={index} name={status.message} actionType={status.status} />
      ))}
    </div>
  )

  return showStats ? colors : null
}

ActivityColorPanel.propTypes = {
  actionsColorsInfo: PropTypes.array.isRequired,
  showStats: PropTypes.bool.isRequired,
}

export default ActivityColorPanel
